/**
 * BrandMark — el asterisco asimétrico de HIVA Nexus.
 *
 * Símbolo definido en Docs/18-BRAND.md §4. Se reusa en sidebar, login,
 * onboarding y splash. Tamaño controlado por className (aplica `currentColor`
 * al stroke + fill del centro, así hereda `text-brand` del padre).
 */

interface BrandMarkProps {
  className?: string
  ariaLabel?: string
}

export function BrandMark({ className = 'h-7 w-7', ariaLabel }: BrandMarkProps) {
  return (
    <svg
      viewBox="-50 -50 100 100"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaLabel ? undefined : 'true'}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : undefined}
    >
      <g stroke="currentColor" strokeLinecap="round" fill="none">
        <line x1="0" y1="-38" x2="0" y2="-10" strokeWidth="6" />
        <line x1="0" y1="38" x2="0" y2="10" strokeWidth="3" />
        <line x1="-38" y1="0" x2="-10" y2="0" strokeWidth="3" />
        <line x1="38" y1="0" x2="10" y2="0" strokeWidth="3" />
        <line x1="-27" y1="-27" x2="-9" y2="-9" strokeWidth="3" />
        <line x1="27" y1="27" x2="9" y2="9" strokeWidth="3" />
      </g>
      <circle cx="0" cy="0" r="5" fill="currentColor" />
    </svg>
  )
}
